import { FC } from 'react';
import { IconProps, defaultIconProps } from './IconProps';

export const IconTrendUp: FC<IconProps> = ({ size, color, strokeWidth, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M18.3333 5.83333L11.7761 12.3905C11.4461 12.7205 11.2811 12.8855 11.0908 12.9474C10.9235 13.0018 10.7432 13.0018 10.5758 12.9474C10.3855 12.8855 10.2205 12.7205 9.89051 12.3905L7.60946 10.1095C7.27945 9.77946 7.11444 9.61446 6.92417 9.55263C6.7568 9.49825 6.57651 9.49825 6.40914 9.55263C6.21887 9.61446 6.05386 9.77946 5.72385 10.1095L1.66666 14.1667M18.3333 5.83333H12.5M18.3333 5.83333V11.6667"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      {...rest}
    />
  </svg>
);

IconTrendUp.defaultProps = defaultIconProps;
